import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPromotions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/promotions', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deletePromotion(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/promotions/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
